module.exports = __webpack_public_path__ + "static/media/circles.1181204b.svg";